<template>
<div v-if="!stage.Category__c">
    
</div>
<div v-else-if="stage.Category__c=='Interview'">
    <interview :stage_key="stage_key" :application_id="application_id" />
</div>
<div v-else-if="stage.Category__c=='Document'">
    <document :stage_key="stage_key" :application_id="application_id" />
</div>
<div v-else-if="stage.Category__c=='Referee'">
    <referee :stage_key="stage_key" :application_id="application_id" />
</div>
<div v-else>
    <stage-block ref="block" :stage_key="stage_key" :application_id="application_id" />
</div>
</template>
<script>
import StageBlock from './StageBlockComponent';
import Document from './DocumentComponent';
import Interview from './interview/InterviewComponent';
import Referee from './RefereeComponent';

export default {
    props: {
        stage_key: String,
        sort: [String, Number],
        application_id: [String, Number]
    },
    components: {
        StageBlock,
        Interview,
        Document,
        Referee
    },
    computed: {
        stage() {
            const stages = this.$store.getters['stage/stages'];
            if(stages.length === 0) return {};
            return stages.find(s => s.Id === this.stage_key);
        },
    },
    mounted() {
        const questionsWithAnswer = this.$store.getters['stage/questionsWithAnswer'];
        if(!questionsWithAnswer[this.stage_key]) {
            this.$store.dispatch('stage/fetchQuestionsWithAnswer', {stageId: this.stage_key, appId: this.application_id});
        }
    },
}
</script>